import { FC } from 'react';
import { BoxProps } from '@mui/material';
import { StyledMultiLineText } from './style';

const KEY_SLICE_INDEX = 7;

export const MultiLineText: FC<
  BoxProps & {
    text: string;
    splitBy: '__br__' | '__new_line__' | '<br />';
  }
> = ({ text, splitBy, ...props }) => (
  <StyledMultiLineText {...props}>
    {text.split(splitBy).map((line, idx, arr) => (
      <p key={line.slice(KEY_SLICE_INDEX) + idx}>
        {line}
        {idx < arr.length - 1 && <br />}
      </p>
    ))}
  </StyledMultiLineText>
);
